/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Form, Modal } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as SERVICE from '../../../constants/service.types';
import { deleteListNotification, socketEmitEvent } from '../../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  LIST_SERVICES_SHOULD_APPEND_SHORT_TOKEN,
  mapPeriodToRangeTime,
  mapRangeTimeToPeriod,
  parseInitialConfig,
} from '../utils.js';

const { confirm } = Modal;

export const useServiceActivationData = ({ data, setType }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [, forceUpdate] = useState();
  const { shortTokenData } = useSelector((state) => state);

  const [timeRequest, setTimeRequest] = useState(new Date().getTime());
  const [activateChain, setActivateChain] = useState([]);
  const [activateChainAccount, setActivateChainAccount] = useState([]);
  const [syncLoading, setSyncLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [initialPerNameSpace, setInitialPerNameSpace] = useState({});
  const [initialPerDevice, setInitialPerDevice] = useState({});
  const [initialPerAccount, setInitialPerAccount] = useState({});
  const [checkUpdatePerNamespace, setCheckUpdatePerNamespace] = useState(true);
  const [checkUpdatePerDevice, setCheckUpdatePerDevice] = useState(true);
  const [checkUpdatePerAccount, setCheckUpdatePerAccount] = useState(true);
  const [devices, setDevices] = useState({
    data: [],
    pagination: {},
    loading: false,
  });
  const [devicesActive, setDevicesActive] = useState({
    data: [],
    pagination: {},
    loading: false,
  });
  const [accounts, setAccounts] = useState({
    data: [],
    pagination: {},
    loading: false,
  });
  const [dataNamespace, setDataNamespace] = useState({
    data: [],
    pagination: {},
    loading: false,
  });
  const [accountsActive, setAccountsActive] = useState({
    data: [],
    pagination: {},
    loading: false,
  });

  const [form] = Form.useForm();
  const [formExpand] = Form.useForm();
  const [formExpandAccount] = Form.useForm();

  const {
    isAuth,
    targetsOfServices,
    targetActiveOfServices,
    configurationService,
    checkLicense,
    activeLicense,
    namespace,
    listNotificationService,
  } = useSelector((state) => state);

  const [checkLicenseReturn, setCheckLicenseReturn] = useState();
  const [activeLicenseReturn, setActiveLicenseReturn] = useState();
  const [, setIsLoadCheckLicense] = useState(false);
  const [isLoadActiveLicense, setIsLoadActiveLicense] = useState([]);
  const [isLoadActiveLicenseAccount, setIsLoadActiveLicenseAccount] = useState(
    []
  );
  const [isLoadActiveLicenseNamespace, setIsLoadActiveLicenseNamespace] =
    useState([]);
  const [license, setLicense] = useState();
  const [licenseInfo, setLicenseInfo] = useState();
  const [expKeys, setExpKeys] = useState([]);
  const [expKeysAccount, setExpKeysAccount] = useState([]);
  const [keyTable, setKeyTable] = useState(Math.random());
  const [dataPerNameTemp, setDataPerNameTemp] = useState({});
  const [service, setService] = useState();
  const [dataSearchDeviceByName, setDataSearchDeviceByName] = useState();
  const [dataNotificationEvent] = useState(['sms', 'email', 'call']);
  const [dataSelectNotificationEvent, setDataSelectNotificationEvent] =
    useState();

  useEffect(() => {
    forceUpdate({});
    form.resetFields();
  }, [form]);

  useEffect(() => {
    if (data) {
      let dataServiceTemp = { ...data };
      let dataPerNamespaceTemp = data?.configuration
        ? { ...data?.configuration }
        : {};
      if (data?.configuration?.timeUpload?.length) {
        const dataTemp = mapPeriodToRangeTime(data?.configuration?.timeUpload);
        dataServiceTemp = {
          ...data,
          configuration: {
            ...data.configuration,
            timeUpload: dataTemp,
          },
        };
        dataPerNamespaceTemp = {
          ...dataPerNamespaceTemp,
          timeUpload: dataTemp,
        };
      }
      setService(dataServiceTemp);
      dispatch(deleteListNotification(null));
      if (data?.configuration?.notificationEvent) {
        setDataSelectNotificationEvent(data?.configuration?.notificationEvent);
      }
      setDataPerNameTemp(dataPerNamespaceTemp);
      setCheckLicenseReturn(null);

      const parsedConfig = data?.configurationInput
        ? JSON.parse(data.configurationInput)
        : null;

      const data1 = parseInitialConfig(parsedConfig?.perNamespace);
      const data2 = parseInitialConfig(parsedConfig?.perDevice);
      const data3 = parseInitialConfig(parsedConfig?.perAccount);

      setInitialPerNameSpace(data1);
      setInitialPerDevice(data2);
      setInitialPerAccount(data3);
    }
  }, [data, dispatch]);

  useEffect(() => {
    if (checkLicense && checkLicense.requestId === timeRequest) {
      setCheckLicenseReturn(checkLicense);
    }
  }, [checkLicense, timeRequest]);

  useEffect(() => {
    if (activeLicense) {
      setActiveLicenseReturn(activeLicense);
    }
    return () => {
      setActiveLicenseReturn(null);
    };
  }, [activeLicense]);

  const onPerDevices = useCallback(() => {
    if (service) {
      let dataBody = {
        serviceId: service.id,
        timeRequest,
        page: 0,
        size: 10,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_TARGET_ACTIVE_BY_SERVICE_ID,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, namespace, service, timeRequest]);

  const onPerNamespace = useCallback(() => {
    let dataBody = {
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.LIST_SERVICE,
      requestId: new Date().getTime(),
      body: JSON.stringify(dataBody),
    };
    dispatch(socketEmitEvent(dataObj));
  }, [dispatch, namespace]);

  useEffect(() => {
    if (
      configurationService?.perNamespace &&
      JSON.parse(configurationService?.perNamespace)
    ) {
      onPerNamespace();
    } else if (
      configurationService?.perDevices &&
      JSON.parse(configurationService?.perDevices)?.length > 0
    ) {
      onPerDevices();
    } else if (configurationService?.result === -8) {
      setCheckUpdatePerAccount(false);
    }
  }, [configurationService, onPerDevices, onPerNamespace]);

  useEffect(() => {
    if (
      service &&
      (service.activeType?.includes('per_device') ||
        service.activeType?.includes('per_account') ||
        service.activeType?.includes('per_namespace')) &&
      service.id
    ) {
      setLicense(null);
      form.resetFields();
      if (service.activeType?.includes('per_device')) {
        setDevices((state) => ({ ...state, loading: true }));
      }
      if (service.activeType?.includes('per_account')) {
        setAccounts((state) => ({ ...state, loading: true }));
      }
      if (service.activeType?.includes('per_namespace')) {
        setDataNamespace((state) => ({ ...state, loading: true }));
      }
      let dataBody = {
        serviceId: service.id,
        timeRequest,
        page: 0,
        size: 10,
        namespace,
      };
      console.log("🚀 ~ LIST_TARGET_BY_SERVICE_ID ~ dataBody:", dataBody)
      let dataObj = {
        appServiceType: SERVICE.LIST_TARGET_BY_SERVICE_ID,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, form, namespace, service, timeRequest]);

  useEffect(() => {
    if (
      service &&
      (service.activeType?.includes('per_device') ||
        service.activeType?.includes('per_account')) &&
      service.id
    ) {
      setLicense(null);
      let dataBody = {
        serviceId: service.id,
        timeRequest,
        page: 0,
        size: 10,
        namespace,
      };
      console.log("🚀 ~ LIST_TARGET_ACTIVE_BY_SERVICE_ID ~ dataBody:", dataBody)
      let dataObj = {
        appServiceType: SERVICE.LIST_TARGET_ACTIVE_BY_SERVICE_ID,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, form, namespace, service, timeRequest]);

  useEffect(() => {
    if (
      service &&
      targetsOfServices &&
      service.id === targetsOfServices.serviceId
    ) {
      if (service.activeType?.includes('per_device')) {
        setDevices((state) => ({
          data: targetsOfServices.perDevice,
          pagination: {
            ...state.pagination,
            total: targetsOfServices.total,
          },
          loading: false,
        }));
      }
      if (service.activeType?.includes('per_account')) {
        setAccounts((state) => ({
          data: targetsOfServices.perAccount,
          pagination: {
            ...state.pagination,
            total: targetsOfServices.total,
          },
          loading: false,
        }));
      }
      if (service.activeType?.includes('per_namespace')) {
        setDataNamespace((state) => ({
          ...state,
          data: [
            {
              namespace: service.name,
              id: service.id,
              key: service.id,
              active: targetsOfServices.perNamespace ? true : false,
            },
          ],
          loading: false,
        }));
      }
    }
  }, [targetsOfServices, service]);

  useEffect(() => {
    if (
      service &&
      targetActiveOfServices &&
      service.id === targetActiveOfServices.serviceId
    ) {
      if (targetActiveOfServices.perDevice?.length) {
        setDevicesActive((state) => ({
          data: targetActiveOfServices.perDevice,
          pagination: {
            ...state.pagination,
            total: targetActiveOfServices.total,
          },
          loading: false,
        }));
      }
      if (targetActiveOfServices.perAccount?.length) {
        setAccountsActive((state) => ({
          data: targetActiveOfServices.perAccount,
          pagination: {
            ...state.pagination,
            total: targetActiveOfServices.total,
          },
          loading: false,
        }));
      }
    }
  }, [targetActiveOfServices, service]);

  const handleTableChange = useCallback(
    (pagination, _, sort) => {
      if (service) {
        const { field, order } = sort;
        if (service.activeType?.includes('per_device')) {
          setDevices((state) => ({
            ...state,
            pagination: {
              ...state.pagination,
              current: pagination.current,
              pageSize: pagination.pageSize,
            },
            loading: true,
          }));
        }

        if (service.activeType?.includes('per_account')) {
          setAccounts((state) => ({
            ...state,
            pagination: {
              ...state.pagination,
              current: pagination.current,
              pageSize: pagination.pageSize,
            },
            loading: true,
          }));
        }

        let dataBody = {
          serviceId: service.id,
          page: pagination.current - 1,
          size: pagination.pageSize,
          timeRequest,
          namespace,
          field,
          order,
        };
        if (dataSearchDeviceByName) {
          dataBody.subName = dataSearchDeviceByName;
        }
        let dataObj = {
          appServiceType: SERVICE.LIST_TARGET_BY_SERVICE_ID,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, service, timeRequest, dataSearchDeviceByName]
  );

  const handleTableChangeActive = useCallback(
    (pagination, _, sort) => {
      if (service) {
        const { field, order } = sort;
        setDevicesActive((state) => ({
          ...state,
          pagination: {
            ...state.pagination,
            current: pagination.current,
          },
          loading: true,
        }));

        let dataBody = {
          serviceId: service.id,
          page: pagination.current - 1,
          size: pagination.pageSize,
          timeRequest,
          namespace,
          field,
          order,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_TARGET_ACTIVE_BY_SERVICE_ID,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, service, timeRequest]
  );

  const handleTableChangeAccountActive = useCallback(
    (pagination, _, sort) => {
      if (service) {
        const { field, order } = sort;
        setAccountsActive((state) => ({
          ...state,
          pagination: {
            ...state.pagination,
            current: pagination.current,
          },
          loading: true,
        }));

        let dataBody = {
          serviceId: service.id,
          page: pagination.current - 1,
          size: pagination.pageSize,
          timeRequest,
          namespace,
          field,
          order,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_TARGET_ACTIVE_BY_SERVICE_ID,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, service, timeRequest]
  );

  const rowSelection = {
    getCheckboxProps: (record) => ({
      disabled: !(license && !record.service),
      key: record.serial,
    }),
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeys, rows) =>
      setActivateChain(
        rows.map((device) => ({ name: device.name, serial: device.serial }))
      ),
  };

  const rowSelectionAccount = {
    getCheckboxProps: (record) => ({
      disabled: !(license && !record.service),
      key: record.accountId,
    }),
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeys, rows) =>
      setActivateChainAccount(
        rows.map((account) => ({
          fullname: account.fullname,
          accountId: account.accountId,
        }))
      ),
  };

  useEffect(() => {
    if (checkLicenseReturn) {
      setIsLoadCheckLicense(false);
      if (checkLicenseReturn.result === -13) {
        form.setFields([
          {
            name: 'checkCode',
            errors: [t('Invalid license!')],
          },
        ]);
        setLicenseInfo(null);
      } else if (checkLicenseReturn.data) {
        const { size, numberActive, endAt, licenseCode, serviceId } =
          JSON.parse(checkLicenseReturn.data);
        if (service && serviceId !== service.id) {
          form.setFields([
            {
              name: 'checkCode',
              errors: [t('License not found')],
            },
          ]);
          setLicenseInfo(null);
        } else if (new Date().getTime() > new Date(endAt).getTime()) {
          form.setFields([
            {
              name: 'checkCode',
              errors: [t('License expired')],
            },
          ]);
          setLicenseInfo({
            ...JSON.parse(checkLicenseReturn.data),
          });
        } else if (numberActive >= size) {
          form.setFields([
            {
              name: 'checkCode',
              errors: [t('The license has used up its activation turn!')],
            },
          ]);
          setLicenseInfo({
            ...JSON.parse(checkLicenseReturn.data),
          });
        } else {
          setLicense({
            licenseCode: licenseCode,
            size: size,
            numberActive: numberActive,
          });
          setLicenseInfo({
            ...JSON.parse(checkLicenseReturn.data),
          });
        }
      }
    }
    return () => {
      setLicense(null);
    };
  }, [checkLicenseReturn, form, service, t]);

  useEffect(() => {
    if (activeLicenseReturn) {
      const { result, data: rawData } = activeLicenseReturn;
      const { licenseCode, endAt, startAt, deviceSerial, accountId } =
        JSON.parse(rawData);

      setInterval(() => {
        if (service?.activeType?.includes('per_device')) {
          setIsLoadActiveLicense((state) =>
            state.filter((serial) => serial !== deviceSerial)
          );
        }
        if (service?.activeType?.includes('per_account')) {
          setIsLoadActiveLicenseAccount((state) =>
            state.filter((id) => id !== accountId)
          );
        }
        if (service?.activeType?.includes('per_namespace')) {
          setIsLoadActiveLicenseNamespace((state) =>
            state.filter((id) => id !== service?.id)
          );
        }
      }, 2000);

      if (result === 1) {
        setLicense((state) => ({
          ...state,
          numberActive: state?.numberActive + 1,
        }));
        if (service?.activeType?.includes('per_device')) {
          setDevices((state) => ({
            ...state,
            data: state.data.map((device) =>
              device.serial === deviceSerial
                ? {
                  ...device,
                  service: {
                    licenseCode,
                    endAt,
                    startAt,
                  },
                }
                : device
            ),
          }));
        }
        if (service?.activeType?.includes('per_account')) {
          setAccounts((state) => ({
            ...state,
            data: state.data.map((account) =>
              account.accountId === accountId
                ? {
                  ...account,
                  service: {
                    licenseCode,
                    endAt,
                    startAt,
                  },
                }
                : account
            ),
          }));
        }
        if (service?.activeType?.includes('per_namespace')) {
          setDataNamespace((state) => ({
            ...state,
            data: [
              {
                namespace: service.name,
                id: service.id,
                key: service.id,
                active: true,
              },
            ],
            loading: false,
          }));
        }
      }
    }
  }, [activeLicenseReturn, service]);

  const onCheckCode = useCallback(
    (licenseCode) => {
      setIsLoadCheckLicense(true);
      if (isAuth && licenseCode) {
        let dataBody = {
          licenseCode,
          namespace,
        };
        const dataTimeRequest = new Date().getTime();
        setTimeRequest(dataTimeRequest);
        let dataObj = {
          appServiceType: SERVICE.GET_LICENSE_INFO_SERVICE,
          requestId: dataTimeRequest,
          body: JSON.stringify(dataBody),
        };
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, isAuth, namespace]
  );

  const onFinishPerNamespace = useCallback(
    (value) => {
      if (value && service) {
        let dataNotifocation = {};
        if (listNotificationService?.eventInfos) {
          listNotificationService.eventInfos.forEach((item) => {
            dataNotifocation[item?.eventKey] = 0;
          });
        }
        let dataTempValue = { ...value };
        if (value?.timeUpload) {
          dataTempValue.timeUpload = mapRangeTimeToPeriod(value?.timeUpload);
        }
        let dataBody = {
          perNamespace: JSON.stringify({
            ...dataTempValue,
            notificationEvent: {
              ...dataNotifocation,
              ...dataSelectNotificationEvent,
            },
          }),
          perDevices: '',
          perAccount: '',
          serviceId: service.id,
          namespace,
        };
        const dataTimeRequest = new Date().getTime();
        setTimeRequest(dataTimeRequest);
        let dataObj = {
          appServiceType: SERVICE.CONFIGURATION_SERVICE,
          requestId: dataTimeRequest,
          body: JSON.stringify(dataBody),
        };
        setDataPerNameTemp(value);
        setCheckUpdatePerNamespace(true);
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [
      dispatch,
      namespace,
      service,
      dataSelectNotificationEvent,
      listNotificationService,
    ]
  );

  const onFinishPerDevice = useCallback(
    (value, record) => {
      if (value && service) {
        let dataTempValue = { ...value };
        if (value?.periodRecognition) {
          dataTempValue.periodRecognition = mapRangeTimeToPeriod(
            value?.periodRecognition
          );
        }
        let dataBody = {
          perNamespace: '',
          perAccount: '',
          perDevices: JSON.stringify([
            {
              configuration: { ...dataTempValue },
              serial: record?.serial,
            },
          ]),
          serviceId: service.id,
          namespace,
        };
        console.log("🚀 ~ CONFIGURATION_SERVICE ~ dataBody:", dataBody)
        const dataTimeRequest = new Date().getTime();
        setTimeRequest(dataTimeRequest);
        let dataObj = {
          appServiceType: SERVICE.CONFIGURATION_SERVICE,
          requestId: dataTimeRequest,
          body: JSON.stringify(dataBody),
        };
        setCheckUpdatePerDevice(true);
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, service]
  );

  const onFinishPerAccount = useCallback(
    (value, record) => {
      if (value && service) {
        let dataTempValue = { ...value };
        if (value?.periodRecognition) {
          dataTempValue.periodRecognition = mapRangeTimeToPeriod(
            value?.periodRecognition
          );
        }
        let dataBody = {
          perNamespace: '',
          perDevices: '',
          perAccount: JSON.stringify({
            configuration: { ...dataTempValue },
            accountId: record?.accountId,
          }),
          serviceId: service.id,
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.CONFIGURATION_SERVICE,
          requestId: timeRequest,
          body: JSON.stringify(dataBody),
        };
        setCheckUpdatePerAccount(true);
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, service, timeRequest]
  );

  const onActiveDevice = useCallback(
    (deviceSerial) => {
      if (isAuth && license && service && license.numberActive < license.size) {
        setIsLoadActiveLicense((state) => state.concat(deviceSerial));
        let dataBody = {
          serviceId: service.id,
          deviceSerial,
          licenseCode: license.licenseCode,
          namespace,
          accountId: -1,
        };
        let dataObj = {
          appServiceType: SERVICE.ACTIVE_LICENSE_SERVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, isAuth, license, namespace, service]
  );

  const onActiveAccount = useCallback(
    (accountId) => {
      if (isAuth && license && service && license.numberActive < license.size) {
        setIsLoadActiveLicenseAccount((state) => state.concat(accountId));
        let dataBody = {
          serviceId: service.id,
          accountId,
          licenseCode: license.licenseCode,
          namespace,
          deviceSerial: '',
        };
        let dataObj = {
          appServiceType: SERVICE.ACTIVE_LICENSE_SERVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, isAuth, license, namespace, service]
  );

  const onActiveNamespace = useCallback(() => {
    if (isAuth && license && service && license.numberActive < license.size) {
      setIsLoadActiveLicenseNamespace((state) => state.concat(service.id));
      let dataBody = {
        serviceId: service.id,
        accountId: -1,
        licenseCode: license.licenseCode,
        namespace,
        deviceSerial: '',
      };
      let dataObj = {
        appServiceType: SERVICE.ACTIVE_LICENSE_SERVICE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, license, namespace, service]);

  const onDeactivateDevice = useCallback(
    (deviceName, deviceSerial) => {
      if (service) {
        let dataBody = {
          serviceId: service.id,
          accountId: -1,
          deviceSerial,
          namespace,
        };
        console.log("🚀 ~ CANCEL_SERVICE ~ dataBody:", dataBody)
        let dataObj = {
          appServiceType: SERVICE.CANCEL_SERVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        confirm({
          title: t('Deactivate device') + ` "${deviceName}"?`,
          icon: <ExclamationCircleOutlined />,
          okText: t('Deactivate'),
          onOk() {
            return dispatch(socketEmitEvent(dataObj));
          },
          onCancel() { },
        });
      }
    },
    [dispatch, namespace, service, t]
  );

  const onDeactivateAccount = useCallback(
    (fullname, accountId) => {
      if (service) {
        let dataBody = {
          serviceId: service.id,
          accountId,
          deviceSerial: '',
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.CANCEL_SERVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        confirm({
          title: t('Deactivate account') + ` "${fullname}"?`,
          icon: <ExclamationCircleOutlined />,
          okText: t('Deactivate'),
          onOk() {
            return dispatch(socketEmitEvent(dataObj));
          },
          onCancel() { },
        });
      }
    },
    [dispatch, namespace, service, t]
  );

  const onDeactivateNameSpace = useCallback(() => {
    if (service) {
      let dataBody = {
        serviceId: service.id,
        accountId: -1,
        deviceSerial: '',
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.CANCEL_SERVICE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      confirm({
        title: t('Deactivate Namespace?'),
        icon: <ExclamationCircleOutlined />,
        okText: t('Deactivate'),
        onOk() {
          return dispatch(socketEmitEvent(dataObj));
        },
        onCancel() { },
      });
    }
  }, [dispatch, namespace, service, t]);

  const singleActiveDevice = (deviceSerial) => {
    confirm({
      title: t('Do you want to activate this device?'),
      onOk() {
        return onActiveDevice(deviceSerial);
      },
      onCancel() { },
    });
  };

  const singleActiveAccount = (accountId) => {
    confirm({
      title: t('Do you want to activate this account?'),
      onOk() {
        return onActiveAccount(accountId);
      },
      onCancel() { },
    });
  };

  const singleActiveNamespace = () => {
    confirm({
      title: t('Do you want to activate this namespace?'),
      onOk() {
        return onActiveNamespace();
      },
      onCancel() { },
    });
  };

  const syncActivateDevice = useCallback(() => {
    confirm({
      title: t('Do you want to activate selected devices?'),
      content: activateChain.map((device) => device.name).join('; '),
      onOk() {
        setSyncLoading(true);
        let chain = [...activateChain];
        let intervalId = setInterval(() => {
          let device = chain.pop();
          if (device) {
            onActiveDevice(device.serial);
          } else {
            clearInterval(intervalId);
            setSyncLoading(false);
          }
        }, 1500);
      },
      onCancel() { },
    });
  }, [activateChain, onActiveDevice, t]);

  const syncActivateAccount = useCallback(() => {
    confirm({
      title: t('Do you want to activate selected accounts?'),
      content: activateChainAccount
        .map((account) => account.fullname)
        .join('; '),
      onOk() {
        setSyncLoading(true);
        let chain = [...activateChainAccount];
        let intervalId = setInterval(() => {
          let account = chain.pop();
          if (account) {
            onActiveAccount(account.accountId);
          } else {
            clearInterval(intervalId);
            setSyncLoading(false);
          }
        }, 1500);
      },
      onCancel() { },
    });
  }, [activateChainAccount, onActiveAccount, t]);

  const openApplication = () => {
    console.log('🚀 ~ openApplication ~ service:', service);
    console.log('🚀 ~ openApplication ~ shortTokenData:', shortTokenData);
    if (service && service.applicationUrl) {
      if (
        service.id &&
        LIST_SERVICES_SHOULD_APPEND_SHORT_TOKEN.includes(service.id) &&
        shortTokenData?.shortAccessToken
      ) {
        const link = `${service.applicationUrl}&token=${shortTokenData?.shortAccessToken}`;
        window.open(link);
      } else {
        window.open(service.applicationUrl);
      }
    } else {
      const link = `https://resource-api.beex.vn:8050/application/redirect?token=${shortTokenData?.shortAccessToken}&namespace=${namespace}&serviceId=${service?.id}`;
      window.open(link);
    }
  };

  const onSearchDeviceByName = (name) => {
    setDataSearchDeviceByName(name?.trim());
    if (service.activeType?.includes('per_device')) {
      setDevices((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: 1,
          pageSize: 10,
        },
        loading: true,
      }));
    }
    if (service.activeType?.includes('per_account')) {
      setAccounts((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: 1,
          pageSize: 10,
        },
        loading: true,
      }));
    }
    let dataBody = {
      subName: name?.trim(),
      serviceId: service.id,
      page: 0,
      size: 10,
      timeRequest,
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.LIST_TARGET_BY_SERVICE_ID,
      requestId: new Date().getTime(),
      body: JSON.stringify(dataBody),
    };
    dispatch(socketEmitEvent(dataObj));
  };

  const onNotificationEvent = (category) => {
    const dataNotification = dataNotificationEvent?.find((item) =>
      category?.split(';')?.find((item1) => item1 === item)
    );
    if (dataNotification) {
      let dataObj = {
        appServiceType: SERVICE.LIST_NOTIFICATION_EVENT,
        requestId: new Date().getTime(),
        body: JSON.stringify({
          namespace,
          notificationVia: dataNotification,
        }),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  };

  const onChangeEventNotification = (value, eventNotification) => {
    setDataSelectNotificationEvent({
      ...dataSelectNotificationEvent,
      [eventNotification?.eventKey]: value?.target?.checked ? 1 : 0,
    });
  };

  return {
    t,
    step,
    setStep,
    service,
    form,
    formExpand,
    formExpandAccount,
    license,
    licenseInfo,
    isLoadActiveLicense,
    isLoadActiveLicenseAccount,
    isLoadActiveLicenseNamespace,
    devices,
    devicesActive,
    accounts,
    accountsActive,
    dataNamespace,
    rowSelection,
    rowSelectionAccount,
    keyTable,
    setKeyTable,
    expKeys,
    setExpKeys,
    expKeysAccount,
    setExpKeysAccount,
    initialPerNameSpace,
    initialPerDevice,
    initialPerAccount,
    checkUpdatePerNamespace,
    setCheckUpdatePerNamespace,
    checkUpdatePerDevice,
    setCheckUpdatePerDevice,
    checkUpdatePerAccount,
    setCheckUpdatePerAccount,
    dataPerNameTemp,
    listNotificationService,
    dataSelectNotificationEvent,
    syncLoading,
    activateChain,
    activateChainAccount,
    openApplication,
    onCheckCode,
    onPerDevices,
    onNotificationEvent,
    onSearchDeviceByName,
    onChangeEventNotification,
    onFinishPerNamespace,
    onFinishPerDevice,
    onFinishPerAccount,
    handleTableChange,
    handleTableChangeActive,
    handleTableChangeAccountActive,
    onDeactivateDevice,
    singleActiveDevice,
    onDeactivateAccount,
    singleActiveAccount,
    onDeactivateNameSpace,
    singleActiveNamespace,
    syncActivateDevice,
    syncActivateAccount,
  };
};
